import React, { Fragment, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Menu, Popover, Transition } from "@headlessui/react";
import { useAppKitNetwork } from "@reown/appkit/react";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { useWeb3React } from "@web3-react/core";
import { BigNumber } from "bignumber.js";
import { ethers } from "ethers";
import { BsWallet2 } from "react-icons/bs";
import {
  FaArrowCircleUp,
  FaBell,
  FaBullhorn,
  FaExternalLinkAlt,
  FaTelegram,
  FaTimes,
  FaTwitter,
} from "react-icons/fa";
import {
  RiArrowRightLine,
  RiCloseLine,
  RiCoinsLine,
  RiFileCopy2Line,
  RiHome2Line,
  RiMenu3Line,
  RiMessage2Line,
  RiTelegramLine,
  RiTwitterLine,
} from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import Web3 from "web3";
import Web3Modal from "web3modal";
import { useEagerConnect, useInactiveListener } from "../hooks/hooks";
import { injected, walletconnect } from "../libs/ConnectorWeb3";
import { getAppByChainId, getEnv } from "../libs/Env";
import { getSimpleAddress } from "../libs/WebooLib";
import { Context } from "../Store";
import useDarkMode from "./useDarkMode";
import { WalletConnectEVM } from "./WalletConnectEVM";

const solutions = [
  {
    name: "Home",
    description: "Homepage.",
    href: "/",
    icon: RiHome2Line,
  },
  {
    name: "Migration",
    description: "Migrate V1 to V2 tokens.",
    href: "/migrate",
    icon: RiArrowRightLine,
  },
  {
    name: "Audit",
    description: "Earn",
    href: "/audit",
    icon: RiCoinsLine,
  },
  {
    name: "Tokenomic",
    description: "Shill Features.",
    href: "/tokenomic",
    icon: RiCoinsLine,
  },
  {
    name: "Private Sale",
    description: "Private Sale",
    href: "/private-sale",
    icon: RiCoinsLine,
  },
];
const resources = [
  {
    name: "Telegram Chat",
    description:
      "Get all of your questions answered in our forums or contact support.",
    href: "https://t.me/blocksafuofficial",
    icon: FaTelegram,
  },
  {
    name: "Telegram Channel",
    description:
      "Learn how to maximize our platform to get the most out of it.",
    href: "https://t.me/Blocksafuannouncement",
    icon: FaBullhorn,
  },
  {
    name: "Twitter",
    description:
      "Get all of your questions answered in our forums or contact support.",
    href: "https://x.com/BlockSafu",
    icon: FaTwitter,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const Header = () => {
  const [state, dispatch] = useContext(Context);
  const [colorTheme, setTheme] = useDarkMode();
  const [balanceWeboo, setBalanceWeboo] = useState(0);
  const [balanceBNB, setBalanceBNB] = useState(0);
  const location = useLocation();
  const { chainId } = useAppKitNetwork();

  const [navActive, setNavActive] = useState("Home");

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      setNavActive("Home");
    } else if (path === "/tokenomic") {
      setNavActive("Tokenomic");
    } else if (path === "/audit") {
      setNavActive("Audit");
    }
  }, [location.pathname]);

  useEffect(() => {
    async function fetchBalances() {
      if (state.web3 && state.account) {
        const bnb = await state.web3.eth.getBalance(state.account);
        const newBNB = new BigNumber(state.web3.ethers.fromWei(bnb));
        setBalanceBNB(newBNB.toFormat(4));

        const token = await new state.web3.eth.Contract(
          getAppByChainId(chainId).ERC20_ABI,
          state.web3.ethers.toHex(getAppByChainId(chainId).TOKEN_ADDRESS)
        );
        const weboo = await token.methods
          .balanceOf(state.web3.ethers.toHex(state.account))
          .call();
        const newWeboo = new BigNumber(state.web3.ethers.fromWei(weboo));
        setBalanceWeboo(newWeboo.toFormat(4));
      }
    }
    fetchBalances();
  }, [state]);

  const getSimpleAddress = (str) => {
    return str.substr(0, 6) + "..." + str.substr(str.length - 3, str.length);
  };

  const getSimpleAddressMobile = (str) => {
    return str.substr(0, 3) + "..." + str.substr(str.length - 3, str.length);
  };

  const doLogout = async () => {
    dispatch({
      type: "LOGOUT_WALLET_CONNECT",
      payload: true,
    });
  };

  return (
    <>
      <Popover className="relative bg-white dark:bg-grayc-950">
        <div className="px-4 mx-auto lg:px-28 md:px-12 sm:px-8">
          <div className="flex items-center justify-between py-4 border-b-2 border-gray-100 dark:border-gray-900 md:justify-start md:space-x-4">
            <div className="flex items-center justify-start gap-2">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellowc-800 font-medium md:mr-2 mr-6 flex items-center gap-1"
                    : "text-gray-900 dark:text-white md:mr-2 mr-6 font-medium flex items-center gap-1"
                }
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="124" height="30" fill="none" className="hidden md:block lg:block"><path d="M41.054 17.829c0 .431-.055.828-.165 1.19-.113.368-.263.692-.463.984a3.44 3.44 0 0 1-.715.764 4.14 4.14 0 0 1-.944.55c-.353.148-.729.261-1.126.333-.402.075-.857.113-1.375.113H32.68a.77.77 0 0 1-.463-.162c-.145-.113-.217-.304-.217-.579V8.786c0-.275.072-.469.217-.579s.301-.165.463-.165h3.12c.819 0 1.494.078 2.018.232s.958.385 1.311.68.619.671.79 1.094c.179.431.266.918.266 1.462a3.77 3.77 0 0 1-.116.932 3.21 3.21 0 0 1-.347.822c-.153.252-.342.478-.573.672-.232.2-.495.362-.793.489a3.34 3.34 0 0 1 1.054.388c.321.188.608.426.854.715s.434.631.576 1.019.214.816.214 1.282h0zm-2.736-6.142c0-.333-.049-.634-.139-.903s-.234-.498-.434-.686-.455-.327-.773-.428-.738-.151-1.265-.151h-1.884v4.452h2.078c.472 0 .854-.064 1.146-.185.289-.127.527-.292.721-.501a1.95 1.95 0 0 0 .414-.732c.091-.279.137-.572.136-.865h0zm.825 6.252a2.78 2.78 0 0 0-.197-1.083 2.09 2.09 0 0 0-.57-.785c-.255-.214-.564-.373-.947-.486-.376-.107-.854-.162-1.424-.162h-2.183v4.84h2.649a3.65 3.65 0 0 0 1.094-.148c.31-.098.582-.246.819-.44s.42-.44.556-.729.203-.625.203-1.007zm6.229 3.56c0 .058-.014.104-.043.145-.029.035-.072.069-.139.101-.086.03-.175.05-.266.061a3.57 3.57 0 0 1-.434.02c-.143.002-.286-.005-.428-.02a1.26 1.26 0 0 1-.269-.061c-.069-.032-.116-.067-.142-.101-.026-.041-.038-.087-.038-.145V7.342c0-.058.012-.11.038-.148.026-.043.072-.081.142-.11a1.1 1.1 0 0 1 .269-.061c.113-.014.255-.023.428-.023.145-.001.29.006.434.023a1.07 1.07 0 0 1 .266.061c.067.029.11.067.139.11.029.038.043.09.043.148v14.157zm12.079-4.886c0 .779-.101 1.494-.307 2.151-.203.651-.509 1.216-.915 1.688a4.14 4.14 0 0 1-1.526 1.109c-.611.264-1.32.397-2.122.397-.784 0-1.47-.116-2.052-.35s-1.068-.57-1.453-1.016-.677-.987-.868-1.621-.287-1.358-.287-2.162c0-.779.101-1.496.301-2.148s.507-1.219.912-1.693.912-.836 1.517-1.103c.608-.26 1.32-.391 2.127-.391.787 0 1.471.116 2.052.353.582.229 1.068.57 1.456 1.016s.677.984.874 1.621c.191.637.29 1.352.29 2.151zm-1.824.113c0-.518-.046-1.004-.145-1.465-.093-.46-.252-.863-.475-1.21-.217-.347-.515-.622-.892-.819-.373-.203-.845-.304-1.404-.304-.518 0-.964.09-1.334.275a2.43 2.43 0 0 0-.92.781c-.243.336-.42.732-.535 1.193s-.177.961-.177 1.505c0 .524.046 1.016.145 1.476.093.46.252.86.478 1.204s.524.617.897.813c.376.203.845.304 1.407.304.509 0 .952-.09 1.329-.275a2.45 2.45 0 0 0 .926-.773 3.36 3.36 0 0 0 .53-1.19c.113-.46.171-.967.171-1.517zm11.274 3.303l-.012.313a1.05 1.05 0 0 1-.038.223.73.73 0 0 1-.064.159c-.026.046-.081.116-.171.203s-.237.2-.449.333c-.227.138-.467.255-.715.35-.281.108-.57.192-.865.252a4.81 4.81 0 0 1-.967.096c-.686 0-1.294-.113-1.824-.339s-.975-.553-1.331-.987-.628-.97-.816-1.601-.284-1.361-.284-2.188c0-.938.116-1.742.345-2.42s.547-1.227.944-1.659c.393-.421.876-.749 1.413-.958s1.129-.31 1.757-.31c.304 0 .596.029.883.087.289.052.55.13.793.22.237.093.454.2.64.321s.327.226.408.31a1.72 1.72 0 0 1 .179.2c.029.052.058.11.078.18s.033.149.041.226l.012.318c0 .275-.035.469-.096.579s-.142.165-.235.165c-.104 0-.229-.058-.365-.179-.168-.139-.344-.267-.527-.385a3.89 3.89 0 0 0-.77-.388c-.301-.119-.654-.177-1.062-.177-.842 0-1.491.321-1.939.97-.449.643-.674 1.581-.674 2.805 0 .614.058 1.152.174 1.615.122.46.289.845.518 1.158.226.307.504.538.834.692s.703.226 1.129.226a2.74 2.74 0 0 0 1.062-.191 4.17 4.17 0 0 0 .787-.423l.564-.414c.153-.124.269-.188.356-.188.046 0 .091.015.127.043s.064.078.09.142c.026.069.044.153.055.258l.014.365h0zm10.154 1.459c0 .058-.014.107-.043.148s-.075.078-.142.11c-.069.023-.162.046-.281.061s-.272.02-.457.02-.347-.003-.469-.014-.229-.029-.313-.055a.51.51 0 0 1-.206-.104.8.8 0 0 1-.145-.165l-4.023-5.283v5.294c0 .058-.014.104-.043.145-.029.035-.072.069-.136.101a1.3 1.3 0 0 1-.269.061 3.54 3.54 0 0 1-.434.02c-.174 0-.313-.006-.425-.02s-.206-.038-.272-.061c-.069-.032-.116-.067-.142-.101-.026-.041-.035-.087-.035-.145V7.342c0-.058.009-.11.035-.148.026-.043.072-.081.142-.11a1.16 1.16 0 0 1 .272-.061c.113-.014.252-.023.425-.023a3.46 3.46 0 0 1 .434.023c.116.014.203.035.269.061.055.023.102.061.136.11.029.038.043.09.043.148v8.62l3.592-3.963c.058-.075.122-.13.182-.179a1.2 1.2 0 0 1 .229-.116c.087-.032.191-.052.31-.064l.434-.014.446.014c.119.012.217.029.289.055s.124.055.159.093.046.09.046.156c0 .089-.024.176-.069.252a1.35 1.35 0 0 1-.229.298l-3.436 3.459 3.87 5.034c.093.125.156.217.197.295s.058.145.058.206h0zm10.041-3.844c0 .724-.133 1.355-.399 1.902-.272.541-.634.993-1.094 1.36-.463.362-.999.637-1.612.819S82.719 22 82.016 22a6.78 6.78 0 0 1-1.32-.119c-.405-.081-.764-.174-1.074-.287-.31-.107-.57-.223-.782-.347s-.359-.232-.452-.321-.156-.229-.197-.402-.058-.42-.058-.744l.023-.55c.014-.148.035-.269.069-.362s.075-.156.124-.197c.055-.038.121-.059.188-.058.098 0 .24.058.42.18a7.63 7.63 0 0 0 .695.385c.284.142.622.272 1.016.388s.848.177 1.366.177c.339 0 .643-.038.912-.119s.498-.194.686-.344.33-.327.431-.544.148-.46.148-.729c0-.31-.084-.579-.252-.799s-.391-.42-.666-.593a6.66 6.66 0 0 0-.932-.486l-1.071-.483a9.09 9.09 0 0 1-1.071-.579 4.23 4.23 0 0 1-.929-.77 3.59 3.59 0 0 1-.666-1.068c-.168-.408-.252-.9-.252-1.47 0-.654.121-1.233.365-1.734a3.57 3.57 0 0 1 .984-1.236c.417-.33.9-.576 1.462-.738a6.31 6.31 0 0 1 1.786-.243 6.54 6.54 0 0 1 .976.075c.308.044.613.111.912.2.281.087.53.179.753.287.217.107.362.194.434.266.067.069.113.13.139.177.026.052.046.116.067.2s.029.182.035.307l.012.46-.014.518c-.011.142-.029.258-.055.35s-.061.159-.104.2a.26.26 0 0 1-.188.064c-.075 0-.2-.049-.368-.148l-.628-.324c-.249-.116-.535-.223-.86-.316-.327-.098-.68-.145-1.071-.145-.304 0-.567.035-.796.113a1.6 1.6 0 0 0-.564.307c-.151.126-.268.287-.342.469s-.11.379-.11.585c0 .301.081.567.249.787s.391.423.669.596.596.333.952.486l1.083.48c.368.171.73.362 1.08.579s.669.474.949.773c.283.312.51.672.669 1.062.171.402.252.88.252 1.43h0zm13.089 3.08c.084.255.139.457.16.605s-.006.261-.082.336c-.081.072-.217.119-.416.136a8.71 8.71 0 0 1-.813.026c-.362 0-.645-.003-.842-.014-.206-.012-.356-.032-.463-.064s-.18-.078-.223-.133a.64.64 0 0 1-.104-.223l-.9-2.756h-5.173l-.865 2.68c-.029.101-.067.185-.113.249a.42.42 0 0 1-.22.159c-.101.041-.246.067-.434.081l-.738.02c-.327 0-.579-.009-.764-.032s-.31-.072-.379-.151c-.072-.084-.098-.2-.075-.347s.075-.344.159-.593l4.226-12.175c.038-.119.09-.217.148-.289.052-.075.145-.13.266-.171.127-.041.298-.064.518-.075l.868-.014.996.014a2.61 2.61 0 0 1 .579.075c.136.041.234.098.295.174.058.081.113.185.153.318l4.237 12.163h0zm-6.293-10.07h-.012l-1.91 5.833h3.85l-1.928-5.833zm15.921-1.468l-.026.535c-.018.145-.047.26-.084.347s-.084.15-.13.188c-.053.043-.11.066-.171.066h-4.496v3.691h4.218c.064 0 .121.017.168.052s.095.096.136.18.064.197.081.339a3.93 3.93 0 0 1 .029.533c0 .209-.009.388-.029.527a1.46 1.46 0 0 1-.081.353c-.041.09-.084.153-.136.194s-.104.058-.168.058h-4.218v5.112c0 .075-.02.145-.063.203s-.116.101-.229.142a1.87 1.87 0 0 1-.425.09c-.18.023-.406.032-.681.032a5.52 5.52 0 0 1-.674-.032c-.18-.02-.324-.049-.428-.09s-.183-.087-.229-.142-.071-.129-.07-.203V8.922c0-.31.081-.536.241-.672s.353-.208.587-.208h6.467c.061.001.121.021.171.058s.089.101.13.194c.037.087.066.206.084.353s.026.33.026.538h0zm13.437 7.465c0 .839-.122 1.592-.374 2.252-.246.666-.605 1.227-1.088 1.688s-1.074.811-1.78 1.048c-.71.243-1.52.362-2.438.362-.862 0-1.635-.107-2.318-.321-.689-.217-1.268-.541-1.74-.981a4.23 4.23 0 0 1-1.085-1.638c-.252-.654-.377-1.418-.377-2.293V8.424c0-.07.022-.138.064-.194a.46.46 0 0 1 .226-.136c.107-.038.252-.061.428-.084a6.08 6.08 0 0 1 .678-.032l.662.032c.177.023.319.046.423.084a.54.54 0 0 1 .229.136c.045.055.069.123.069.194v8.102c0 .547.067 1.016.203 1.418a2.54 2.54 0 0 0 .579.993c.249.261.55.457.9.588a3.34 3.34 0 0 0 1.172.197c.437 0 .831-.069 1.175-.203a2.34 2.34 0 0 0 .883-.588c.238-.261.426-.579.556-.955s.197-.811.197-1.291V8.424c-.001-.07.022-.138.064-.194s.115-.101.223-.136.248-.061.428-.084.405-.032.674-.032l.66.032c.174.023.316.046.42.084s.182.084.223.136.064.124.064.194v8.227h0z" fill="#0d3b6f"></path><path d="M24.891 3.75c-5.39-.632-8.266-1.447-12.466-3.75v5.111l7.548 4.42v8.662l-7.548 4.301-7.573-4.309 7.573 7.658V30c6.701-4.131 12.947-9.332 12.467-26.25h0z" fill="#07203d"></path><path d="M.022 3.75C5.533 3.092 8.634 1.99 12.425 0v5.111L4.86 9.53v8.662l7.565 7.65V30C3.159 24.34-.316 17.965.022 3.75z" fill="#0d3b6f"></path><path d="M12.603 5.403L5.356 9.844v8.415l7.48 3.74 7.013-4.208V9.844l-7.246-4.441z" fill="#fefefe"></path><g fill-rule="evenodd"><path d="M7.828 8.703c.22-.248 3.435-1.97 4.081-2.389.344-.223.203-.614.865-.532.252.031.558.212.369.502-.147.226-.447.121-.732.231-.888.343-2.82 1.649-3.735 2.187.212.359.537.239.928.374.438.152.292.591-.18.635-.703.064-.517-.273-.803-.495-.179-.139-.698-.31-.793-.514zm-2.836.678l.791.46c.172-.135 1.025-.596 1.25-.684.329.073.544.302.85.436.397.173.812-.026.843.495-.129.241-.323.313-.651.269-.55-.075-.572-.883-1.173-.649-.165.064-.581.284-.681.389l1.821 1.059 3.011-1.79c-.515-.431-1.125-.228-1.179-.602.072-.497.838-.514 1.063-.13.302.516.582.338.956.732-.09.139-.011.047-.154.149l-3.29 1.877 2.931 1.705c.33-.167 1.801-.931 1.933-1.143-.166-.135-1.62-.982-1.732-.988-.103-.006-.339.118-.431.185-.25.182-.105.24-.313.41-.529.431-1.614-.391-.393-.593.255-.042.379-.115.586-.239.756-.454.522-.271 2.128.614l1.009.686-2.266 1.37.768.447 3.051-1.764c-.201-.212-1.296-.799-1.642-1l-1.738-1.055c.127-.235.753-.497 1.005-.646.346-.204.725-.449 1.078-.592-.194-.457-.805-.299-1.168-.544l-.005-.35c.46-.226.823-.315 1.09.15.189.328.663.399.916.658-.087.182-.817.548-1.024.667-.254.145-.911.472-1.059.658.072.096 2.733 1.693 2.994 1.796l.712-.412c-.1-.175-1.639-.994-1.97-1.047-1.053-.169-.372-.893.284-.647.306.114.168.318.582.562l1.507.899.724-.418c-.134-.168-1.653-.98-1.818-1.021-.428-.107-.327.066-.695-.242-.01-.4.267-.522.687-.458.486.074.253.308.683.568l1.57.891.698-.389c-.455-.355-2.854-1.617-3.591-2.063l-1.743-.986c-.107-.008-1.552.833-1.762.98.334.568.975.091 1.179.662-.113.466-.816.501-1.07.103-.16-.251-.134-.232-.446-.395-.212-.11-.431-.195-.514-.371.176-.152.791-.481 1.006-.6 2.036-1.126 1.119-1.171 3.172.001l4.196 2.424.791-.462-7.626-4.47L4.993 9.38z" fill="#f9c309"></path><path d="M18.427 18.465l-2.509 1.448-1.259.722c-.228.14-.436.226-.572.389-.206.247-.208.455-.649.377-.125-.227-.126-.419.039-.687.223-.361.301-.195.716-.308l3.808-2.182c.017-.164.042-.391.013-.553-.057-.321-.147-.15-.179-.425-.036-.305.238-.689.479-.721.551-.073.226.581.167.78-.084.283-.002.807-.056 1.16zm-1.644-.344c-.026-.038-.035-.023-.061-.121-.054-.205.005-.281.079-.45.135-.306.09-.362.081-.721-.018-.732.083-.628.624-.92.411-.222 1.714-1.077 2.058-1.133l.005 2.178c.036.399.367.306.113.839-.289.607-.961.473-.649-.228.199-.449.125-1.542.091-2.052-.154.018-1.613.846-1.717.965-.334.384.131.737.108 1.066-.024.344-.355.765-.731.578zm-.736-3.208c-.36.059-.334-.059-.629.102l-1.451.887-.014 3.317c.176-.035 1.657-.877 1.799-1.048.183-.631-.208-.615-.16-1.033.08-.694.945-.843.771-.153-.04.16-.117.217-.148.396-.225 1.309.627.75-1.342 1.846-.279.155-1.1.705-1.337.708l-.016-4.288c.283-.257 1.42-.833 1.858-1.091.413-.242.415-.705.807-.601.211.056.225.281.162.488-.066.218-.193.29-.302.47zm3.512-5.047l-.029 4.028-1.525.845.001-3.98-.724.418c-.078.662.143 3.725 0 3.998-.195.279-1.812 1.056-2.197 1.363-.108.958.318.573.145 1.17-.114.393-.427.58-.738.364-.112-.479.116-.434.154-.822.08-.81-.217-.88.331-1.174l.801-.46 1.108-.654-.007-3.552-.712.412.001 1.421c-.04.122-1.205.745-1.415.864-.229.13-.547.294-.681.46s-.312.549-.613.328c-.264-.202-.08-.604.102-.784.3-.297.388-.007.811-.268l1.347-.843v-.919l-3.051 1.764-.019 8.854 7.701-4.383v-2.699-2.999-3.215l-.791.462z" fill="#f76200"></path><path d="M7.337 18.217l2.92 1.625v-1.99c-.508-.494-.588-.195-.937-.372-.23-.117-.545-.604-.255-.904.412-.191.53.299.746.474s.622.342.861.512l.012 3.008c-.386-.016-3.136-1.838-3.776-2.104-.112-.94.117-2.056-.112-2.603-.352-.839.462-.774.671-.19.153.425-.056.419-.123.686-.045.181-.031 1.615-.006 1.857zM6.214 17.3c.031.215.122.256.16.448.102.519-.381.475-.598.224-.403-.467-.099-.606-.022-.918.085-.345-.057-2.834.038-3.58.187.036 2.461 1.361 2.657 1.519l.022 2.559c.506.425.666.172.96.36.265.17.387.56.231.894-.537.103-.514-.305-.832-.531-1.07-.76-.81.256-.832-3.078l-1.787-.994.003 3.097zm4.612-.45c-.518.173-.535-.267-.855-.502-.238-.175-.762-.32-.819-.611l-.007-2.881c.394.003.62.45 1.143.46.458.009.682.485.553.953-.749.181-.336-.406-1.264-.701l.033 2.059c.503.416.586.162.925.331.305.152.388.554.292.893zm-5.892 1.442l7.715 4.408.019-8.854-.768-.447-.072 7.215c.085.346.285.41.062.787-.38.057-.575-.161-.674-.469-.139-.437.155-.337.163-.848v-6.987l-2.931-1.705v2.713L5.785 12.6l-.003-2.759-.791-.46-.029 4.456-.029 4.456zm3.104-4.89l.005-2.245-1.821-1.059-.002 2.262 1.817 1.043z" fill="#fd8c0a"></path><path d="M18.435 10.499v3.52l.682-.363.015-3.546-.698.389z" fill="#f76200"></path></g></svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="93" height="22" fill="none" className="block md:hidden lg:hidden"><path d="M30.79 13.372c0 .323-.041.621-.124.893-.084.276-.197.519-.347.738a2.58 2.58 0 0 1-.536.573 3.1 3.1 0 0 1-.708.413c-.265.111-.547.196-.845.249a7.2 7.2 0 0 1-1.031.085H24.51c-.116 0-.208-.04-.274-.121-.109-.085-.163-.228-.163-.434V6.59c0-.206.054-.351.163-.434s.226-.124.347-.124h2.34c.614 0 1.121.058 1.514.174s.718.289.983.51.464.503.593.821c.134.323.199.688.199 1.097 0 .194-.029.4-.087.699-.058.299-.154.581-.26.616-.115.189-.257.358-.43.504-.174.15-.371.271-.595.367.294.111.558.251.791.291.241.14.456.32.64.536s.326.473.432.764c.105.291.16.612.16.962h0zm-2.052-4.607c0-.249-.037-.475-.104-.677s-.175-.374-.326-.514-.341-.245-.58-.321-.553-.113-.949-.113h-1.413v3.339h1.559c.354 0 .64-.048.859-.139.216-.095.395-.219.54-.376a1.46 1.46 0 0 0 .311-.549c.068-.209.103-.429.103-.649h0zm.619 4.689a2.08 2.08 0 0 0-.148-.812 1.57 1.57 0 0 0-.427-.589c-.191-.16-.423-.279-.71-.364s-.641-.121-1.068-.121h-1.637v3.63h1.987c.272 0 .527-.032.821-.111s.562-.185.614-.33.315-.33.417-.547.152-.468.152-.755zm4.667 2.67c0 .043-.01.078-.032.109-.022.026-.054.052-.104.076a1.08 1.08 0 0 1-.2.045 2.68 2.68 0 0 1-.325.015c-.107.001-.215-.004-.321-.015s-.201-.024-.269-.045c-.052-.024-.087-.05-.107-.076s-.028-.065-.028-.109V5.507c0-.043.009-.082.028-.111s.054-.061.107-.082a.82.82 0 0 1 .201-.045c.085-.011.191-.017.321-.017.109-.001.218.004.325.017s.14.026.2.045c.05.022.082.05.104.082.022.029.032.068.032.111v10.618zm9.059-3.664c0 .584-.076 1.121-.23 1.613-.152.488-.382.912-.686 1.266s-.68.627-1.144.832c-.458.198-.99.298-1.592.298-.588 0-1.102-.087-1.539-.262s-.801-.428-1.09-.762-.507-.741-.651-1.216-.216-1.018-.216-1.622c0-.584.076-1.122.226-1.611s.38-.914.684-1.27.684-.627 1.138-.827c.456-.195.99-.293 1.595-.293.59 0 1.103.087 1.539.265.436.172.801.428 1.092.762s.507.738.655 1.216c.143.478.218 1.014.218 1.613zm-1.368.085c0-.389-.034-.753-.109-1.099s-.189-.647-.356-.907-.386-.467-.669-.614c-.28-.152-.634-.228-1.053-.228-.389 0-.723.068-1.001.206a1.82 1.82 0 0 0-.69.586c-.182.252-.315.549-.401.895s-.133.721-.133 1.129c0 .393.034.762.109 1.107s.189.645.358.903.393.463.673.61c.282.152.634.228 1.055.228.382 0 .714-.068.997-.206s.518-.339.695-.58a2.52 2.52 0 0 0 .397-.892c.085-.345.128-.725.128-1.138zm8.456 2.477l-.009.235a.79.79 0 0 1-.028.167.55.55 0 0 1-.048.119c-.019.034-.061.087-.128.152s-.178.15-.337.25c-.17.103-.35.191-.536.262a3.14 3.14 0 0 1-.649.189 3.61 3.61 0 0 1-.725.072c-.514 0-.971-.085-1.368-.254s-.731-.412-.996-.740-.467-.728-.612-1.201-.213-1.021-.213-1.641c0-.703.087-1.307.258-1.815s.41-.921.708-1.244c.295-.316.657-.562 1.06-.719s.847-.232 1.318-.232c.228 0 .447.022.662.065s.412.097.595.165c.178.07.341.15.48.241s.245.169.306.232a1.29 1.29 0 0 1 .134.15c.022.039.043.082.059.135s.025.111.031.169l.009.239c0 .206-.026.351-.072.434s-.106.124-.176.124c-.078 0-.172-.043-.274-.134a4.43 4.43 0 0 0-.395-.289 2.92 2.92 0 0 0-.578-.291c-.226-.089-.49-.133-.797-.133-.632 0-1.118.241-1.454.728-.337.482-.505 1.186-.505 2.104 0 .461.043.864.131 1.211.091.345.217.634.388.869.17.23.378.403.625.519s.527.17.847.17.611-.047.797-.143a3.13 3.13 0 0 0 .59-.317l.423-.311c.115-.093.202-.141.267-.141.034 0 .068.011.095.032s.048.058.067.107c.02.052.033.115.041.193l.01.274h0zm7.616 1.094c0 .043-.01.08-.032.111s-.056.058-.106.082c-.052.017-.122.034-.211.045s-.204.015-.343.015-.26-.002-.352-.01-.172-.022-.235-.041a.38.38 0 0 1-.154-.078.6.6 0 0 1-.109-.124l-3.017-3.962v3.971c0 .043-.01.078-.032.109-.022.026-.054.052-.102.076a.98.98 0 0 1-.202.045 2.65 2.65 0 0 1-.325.015c-.131 0-.235-.004-.319-.015s-.154-.028-.204-.045c-.052-.024-.087-.05-.106-.076s-.026-.065-.026-.109V5.507c0-.043.007-.082.026-.111s.054-.061.106-.082a.87.87 0 0 1 .204-.045c.085-.011.189-.017.319-.017.109-.001.218.004.325.017s.152.026.202.045c.041.017.076.046.102.082.022.029.032.068.032.111v6.465l2.694-2.972c.043-.056.091-.098.136-.134a.9.9 0 0 1 .172-.087c.065-.024.143-.039.233-.048l.325-.01.335.01c.089.009.163.022.217.041s.093.041.119.07.034.067.034.117c0 .067-.018.132-.052.189a1.01 1.01 0 0 1-.172.224l-2.577 2.594 2.902 3.776c.07.094.117.163.148.221s.043.109.043.154h0zm7.531-2.883c0 .543-.1 1.016-.299 1.426-.204.406-.476.745-.821 1.02-.347.272-.749.478-1.209.614s-1.009.206-1.654.206a5.08 5.08 0 0 1-.99-.089c-.304-.061-.573-.131-.806-.215s-.428-.167-.587-.261-.269-.174-.339-.241-.117-.172-.148-.302-.043-.315-.043-.558l.017-.412c.011-.111.026-.202.052-.272s.056-.117.093-.148a.19.19 0 0 1 .141-.043c.073 0 .18.043.315.135a5.72 5.72 0 0 0 .521.289c.213.106.467.204.762.291s.636.133 1.025.133c.254 0 .482-.028.684-.089s.373-.146.515-.258.249-.245.323-.408.111-.345.111-.547c0-.232-.063-.434-.189-.599s-.293-.315-.499-.445a4.99 4.99 0 0 0-.699-.364l-.803-.362a6.82 6.82 0 0 1-.803-.434 3.17 3.17 0 0 1-.697-.578 2.69 2.69 0 0 1-.499-.801c-.126-.306-.189-.675-.189-1.102 0-.491.091-.925.274-1.301s.426-.687.738-.927c.313-.247.675-.432 1.097-.553a4.73 4.73 0 0 1 1.34-.182c.25 0 .494.019.732.056s.46.083.684.15c.211.065.397.134.565.215.163.08.272.146.325.2s.085.098.104.133.034.087.05.15.022.136.026.23l.009.345-.01.389c-.008.106-.022.193-.041.262s-.046.119-.078.15a.19.19 0 0 1-.141.048c-.056 0-.15-.037-.276-.111l-.471-.243c-.187-.087-.401-.167-.645-.237s-.51-.109-.803-.109c-.228 0-.425.026-.597.085a1.2 1.2 0 0 0-.423.23c-.113.094-.201.215-.256.351s-.083.284-.083.439c0 .226.061.425.187.59s.293.317.502.447.448.25.714.364l.812.36c.276.128.548.271.81.434s.502.355.712.58c.212.234.383.504.502.797.128.302.189.66.189 1.072h0zm9.817 2.31c.063.191.104.343.12.454s-.004.196-.061.252c-.061.054-.163.089-.312.102a6.53 6.53 0 0 1-.61.019c-.271 0-.484-.002-.631-.01-.155-.009-.267-.024-.347-.048s-.135-.058-.167-.1a.48.48 0 0 1-.078-.167l-.675-2.067h-3.88l-.649 2.01c-.022.076-.05.139-.085.187a.32.32 0 0 1-.165.119c-.076.031-.184.05-.325.061l-.553.015c-.245 0-.434-.007-.573-.024s-.232-.054-.284-.113c-.054-.063-.073-.15-.056-.26s.056-.258.119-.445l3.17-9.131c.028-.089.067-.163.111-.217.039-.056.109-.098.199-.128.096-.031.224-.048.389-.056l.651-.01.747.01c.147.012.268.025.365.056.102.031.175.073.221.13.043.061.085.139.115.239l3.178 9.122h0zm-4.72-7.552h-.009l-1.432 4.375h2.885l-1.445-4.375zm11.941-1.101l-.019.401c-.013.109-.035.195-.063.26s-.063.112-.097.141c-.04.032-.083.049-.128.049h-3.372v2.768h3.164c.048 0 .091.013.126.039s.071.072.102.135.048.148.061.254a2.95 2.95 0 0 1 .022.4c0 .157-.007.291-.022.395a1.1 1.1 0 0 1-.061.265c-.031.067-.063.115-.102.145s-.078.043-.126.043h-3.164v3.834c0 .056-.015.109-.047.152s-.087.076-.172.106a1.4 1.4 0 0 1-.319.068c-.135.017-.304.024-.511.024a4.14 4.14 0 0 1-.505-.024c-.135-.015-.243-.037-.321-.068s-.137-.065-.172-.106-.053-.097-.052-.152V6.691c0-.232.061-.402.181-.504s.265-.156.44-.156h4.85c.046.001.091.016.128.043s.067.076.097.145c.028.065.05.154.063.265s.019.247.019.403h0zm10.078 5.599c0 .629-.091 1.194-.28 1.689-.184.499-.454.92-.816 1.266s-.806.607-1.335.784c-.532.182-1.14.272-1.828.272-.647 0-1.226-.08-1.739-.241-.516-.163-.951-.406-1.305-.736a3.17 3.17 0 0 1-.814-1.228c-.189-.491-.283-1.063-.283-1.72V6.318c0-.052.016-.103.048-.145a.34.34 0 0 1 .169-.102c.08-.028.189-.045.321-.063a4.56 4.56 0 0 1 .508-.024l.497.024c.133.017.239.035.317.063a.4.4 0 0 1 .172.102c.034.041.052.092.052.145v6.077c0 .41.05.762.152 1.063s.256.55.434.745c.187.196.412.343.675.441s.569.148.879.148c.328 0 .623-.052.881-.152a1.75 1.75 0 0 0 .662-.441c.178-.196.319-.434.417-.716s.148-.608.148-.968V6.318c-.001-.052.016-.103.048-.145s.086-.076.167-.102.186-.045.321-.063.303-.024.505-.024l.495.024c.131.017.237.035.315.063s.136.063.167.102.048.093.048.145v6.17h0z" fill="#0d3b6f"></path><path d="M18.668 2.812c-4.043-.474-6.2-1.085-9.35-2.812v3.833l5.661 3.315v6.497l-5.661 3.226-5.679-3.232 5.679 5.744V22c5.026-3.098 9.71-6.999 9.35-19.688h0z" fill="#07203d"></path><path d="M.017 2.812c4.133-.493 6.475-1.369 9.301-2.812v3.833L3.645 7.148v6.497l5.673 5.735V22C2.369 18.255-.237 13.474.017 2.812z" fill="#0d3b6f"></path><path d="M9.452 4.052L4.017 7.383v6.311l5.61 2.805 5.26-3.156V7.383L9.452 4.052z" fill="#fefefe"></path><g fill-rule="evenodd"><path d="M5.871 6.527c.165-.186 2.576-1.477 3.061-1.792.258-.167.152-.461.649-.399.189.023.418.159.277.377-.11.169-.335.091-.549.173-.666.257-2.115 1.237-2.801 1.64.159.269.403.179.696.281.328.114.219.443-.135.476-.527.048-.388-.205-.602-.371-.134-.104-.523-.233-.596-.386zm-2.127.509l.593.345c.129-.101.769-.447.938-.513.247.055.408.227.638.327.298.13.609-.019.632.371-.097.181-.242.235-.488.202-.412-.056-.429-.662-.88-.487-.124.048-.436.213-.511.292l1.366.794 2.258-1.342c-.386-.323-.843-.171-.883-.452.054-.372.628-.385.797-.097.226.387.436.253.717.549-.067.104-.008.035-.115.112l-2.468 1.408 2.198 1.279c.247-.125 1.351-.698 1.45-.857-.124-.101-1.215-.737-1.299-.741-.077-.004-.254.088-.323.139-.187.136-.079.18-.235.307-.396.323-1.21-.293-.294-.445.191-.031.284-.086.439-.179.567-.34.391-.203 1.596.461l.757.514-1.7 1.027.576.335 2.288-1.323c-.151-.159-.972-.599-1.231-.75l-1.303-.791c.095-.176.565-.373.754-.485.259-.153.544-.337.808-.444-.145-.343-.604-.224-.876-.408l-.004-.262c.345-.17.617-.237.817.112.142.246.497.299.687.494-.065.136-.613.411-.768.5-.19.109-.683.354-.794.494.054.072 2.05 1.27 2.246 1.347l.534-.309c-.075-.131-1.229-.745-1.477-.785-.79-.127-.279-.67.213-.485.229.085.126.239.436.422l1.13.674.543-.314c-.1-.126-1.24-.735-1.363-.766-.321-.08-.245.049-.521-.181-.008-.3.2-.392.515-.344.365.056.19.231.512.426l1.178.668.523-.292c-.341-.266-2.141-1.213-2.693-1.547l-1.307-.74c-.08-.006-1.164.625-1.321.735.25.426.731.068.884.497-.085.349-.612.376-.803.077-.12-.188-.1-.174-.334-.296-.159-.083-.323-.146-.386-.278.132-.114.593-.361.754-.45 1.527-.845.839-.878 2.379.001l3.147 1.818.593-.347-5.72-3.352L3.745 7.035z" fill="#f9c309"></path><path d="M13.821 13.849l-1.882 1.086-.944.541c-.171.105-.327.17-.429.292-.154.185-.156.341-.487.283-.093-.17-.094-.314.029-.515.167-.271.226-.146.537-.231l2.856-1.636c.013-.123.031-.293.01-.415-.043-.241-.11-.112-.134-.319-.027-.228.178-.516.359-.541.413-.055.169.436.125.585-.063.212-.001.605-.042.87zm-1.233-.258c-.019-.028-.026-.017-.046-.091-.04-.153.004-.211.059-.337.101-.229.067-.272.061-.541-.014-.549.062-.471.468-.69.308-.166 1.285-.808 1.544-.85l.004 1.634c.027.299.275.229.085.629-.217.455-.721.355-.487-.171.149-.337.094-1.157.068-1.539-.115.014-1.21.635-1.288.724-.25.288.098.553.081.8-.018.258-.266.574-.548.434zm-.552-2.406c-.27.044-.251-.044-.472.076l-1.088.665-.011 2.488c.132-.026 1.243-.658 1.349-.786.137-.473-.156-.461-.12-.775.06-.52.709-.632.578-.115-.03.12-.088.163-.111.297-.169.982.47.562-1.007 1.385-.209.116-.825.529-.002.531l-.012-3.216c.212-.193 1.065-.625 1.394-.818.31-.181.311-.529.605-.451.158.042.169.211.122.366-.05.163-.145.217-.227.352zm2.634-3.785l-.022 3.021-1.144.634.001-2.985-.543.314c-.058.496.107 2.794 0 2.998-.146.209-1.359.792-1.648 1.022-.081.719.238.43.109.877-.086.295-.32.435-.554.273-.084-.359.087-.326.115-.616.06-.608-.163-.66.248-.881l.601-.345.831-.49-.005-2.664-.534.309.001 1.066c-.03.091-.904.559-1.061.648-.172.097-.41.22-.511.345s-.234.412-.46.246c-.198-.151-.06-.453.076-.588.225-.223.291-.005.608-.201l1.01-.632v-.689l-2.288 1.323-.014 6.641 5.776-3.287v-2.024-2.249-2.411l-.593.346z" fill="#f76200"></path><path d="M5.503 13.663l2.19 1.219v-1.492c-.381-.371-.441-.146-.703-.279-.172-.088-.409-.453-.191-.678.309-.143.397.224.559.356s.467.256.646.384l.009 2.256c-.289-.012-2.352-1.379-2.832-1.578-.084-.705.088-1.542-.084-1.952-.264-.629.347-.58.503-.142.115.318-.042.314-.092.514-.034.136-.023 1.211-.005 1.393zM4.661 12.975c.023.161.091.192.12.336.076.389-.286.356-.449.168-.302-.35-.074-.454-.016-.688.064-.259-.043-2.125.028-2.685.14.027 1.846 1.02 1.993 1.139l.016 1.919c.38.319.5.129.72.27.199.127.29.42.173.671-.403.077-.385-.229-.624-.398-.802-.57-.607.192-.624-2.308l-1.34-.745.002 2.323zm3.459-.337c-.389.129-.401-.2-.641-.377-.179-.131-.571-.24-.614-.458l-.005-2.161c.295.002.465.337.857.345.343.007.511.363.414.715-.562.136-.252-.305-.948-.526l.025 1.544c.377.312.44.121.694.248.228.114.291.415.219.669zm-4.419 1.081l5.786 3.306.014-6.641-.576-.335-.054 5.411c.064.259.214.308.047.59-.285.043-.431-.121-.506-.352-.104-.328.116-.253.122-.636V10.55l-2.198-1.279v2.035L3.659 9.45l-.002-2.069-.593-.345-.022 3.342-.022 3.341zm2.328-3.667l.004-1.684-1.366-.794-.002 1.696 1.363.782z" fill="#fd8c0a"></path><path d="M13.826 7.874v2.64l.512-.272.011-2.659-.523.292z" fill="#f76200"></path></g></svg>
              </NavLink>
            </div>

            <Popover.Group
              as="nav"
              className="hidden w-auto px-6 py-4 space-x-6 xl:space-x-10 lg:space-x-10 md:space-x-6 rounded-2xl md:flex"
            >
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? "text-gray-900 dark:text-white font-medium flex items-center gap-4"
                    : "dark:text-grayc-200 text-grayc-600  flex items-center gap-4"
                }
                onClick={() => setNavActive("Home")}
              >
                {navActive === "Home" && (
                  <div className="p-2 rounded-full bg-yellowc-400 dark:bg-yellowc-500"></div>
                )}
                Home
              </NavLink>
              <a
                href="#"
                className="dark:text-grayc-200 text-grayc-600  flex items-center gap-4"
                onClick={(e) => {
                  e.preventDefault();
                  window.open("https://token.blocksafu.com", "_blank");
                }}
              >
                Tokenomic
              </a>
              <a
                href="#"
                className="dark:text-grayc-200 text-grayc-600  flex items-center gap-4"
                onClick={(e) => {
                  e.preventDefault();
                  window.open("https://blocksafu.com", "_blank");
                }}
              >
                Audit
              </a>
            </Popover.Group>
            <div className="items-center justify-end hidden gap-5 md:flex md:flex-1 lg:w-0">
              <div className="">
                {colorTheme === "light" ? (
                  <div className="p-4 text-black bg-white border-2 rounded-full border-grayc-800 dark:bg-grayc-900 dark:text-white">
                    <svg
                      onClick={() => setTheme("light")}
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="p-4 text-black bg-gray-100 border-gray-400 rounded-full border-1">
                    <svg
                      onClick={() => setTheme("dark")}
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                      />
                    </svg>
                  </div>
                )}
              </div>

              <WalletConnectEVM />
            </div>

            {/* mobile */}
            <div className="flex items-center gap-2 -my-2 md:hidden">
              <Menu as="div" className="relative inline-block text-left">
                <Menu.Button as="div">
                  <WalletConnectEVM />
                </Menu.Button>
                <Menu.Items className="absolute left-0 w-56 px-4 py-4 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg dark:divide-gray-800 dark:bg-gray-900 ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <Menu.Item>
                    {({ active }) => (
                      <>
                        <div className="pb-2 text-sm font-bold text-black dark:text-white">
                          Balance
                        </div>
                        <div className="flex items-center justify-start gap-2 py-2 border-0">
                          <img
                            src="./images/icon-reward/weboo.svg"
                            className="w-5 h-5"
                            alt=""
                          />
                          <span className="text-sm text-black dark:text-white">
                            {balanceWeboo} OpenCoin
                          </span>
                        </div>
                        <div className="flex items-center justify-start gap-2 py-2 border-0">
                          <img
                            src="./images/icon-reward/bnb.svg"
                            className="w-5 h-5"
                            alt=""
                          />
                          <span className="text-sm text-black dark:text-white">
                            {balanceBNB} BNB
                          </span>
                        </div>
                        <div className="flex pt-3">
                          <button
                            className="flex items-center gap-2 text-sm font-bold text-yellowc-500"
                            type="button"
                            onClick={() => doLogout()}
                          >
                            <RiArrowRightLine className="w-3 h-3" /> Disconnect
                          </button>
                        </div>
                      </>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Menu>

              {colorTheme === "light" ? (
                <div className="p-2 text-black bg-white rounded-full dark:bg-grayc-800 dark:text-white">
                  <svg
                    onClick={() => setTheme("light")}
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                    />
                  </svg>
                </div>
              ) : (
                <div className="p-2 text-white bg-gray-900 rounded-full">
                  <svg
                    onClick={() => setTheme("dark")}
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                    />
                  </svg>
                </div>
              )}

              <Popover.Button className="inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-full dark:bg-grayc-800 hover:black hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                <span className="sr-only">Open menu</span>
                <RiMenu3Line className="w-6 h-6" />
              </Popover.Button>
            </div>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="relative inset-x-0 top-0 px-4 py-4 transition origin-top-right transform md:hidden"
          >
            <div className="z-20 bg-white divide-y-2 rounded-lg shadow-lg dark:bg-grayc-800 ring-1 ring-black ring-opacity-5 divide-gray-50 dark:divide-gray-900">
              <div className="px-5 pt-5 pb-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    {/* <img src="" alt="" width={50} /> */}
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md dark:bg-gray-900 hover:black hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                      <span className="sr-only">Close menu</span>
                      <RiCloseLine className="w-5 h-5" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="mt-6">
                  <nav className="grid gap-y-8">
                    {solutions.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.href}
                        className={({ isActive }) =>
                          isActive
                            ? "flex items-center p-3 -m-3 rounded-md hover:bg-gray-50"
                            : "flex items-center p-3 -m-3 rounded-md hover:bg-gray-50"
                        }
                      >
                        <item.icon
                          className="flex-shrink-0 w-6 h-6 text-yellowc-500"
                          aria-hidden="true"
                        />
                        <span className="ml-3 text-base font-medium text-gray-900 dark:text-gray-400">
                          {item.name}
                        </span>
                      </NavLink>
                    ))}
                  </nav>
                </div>
              </div>
              <div className="px-5 py-6 space-y-6">
                <div className="grid grid-cols-2 gap-y-4 gap-x-8">
                  {resources.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="text-base font-medium text-gray-900 hover:text-gray-700 dark:text-gray-400"
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                <div>
                  <div className="py-2 md:p-2">
                    {/*<ModalWallet />*/}
                    {/*<ModalWeb3 />*/}
                  </div>

                  <div className="flex items-center justify-between gap-2">
                    <WalletConnectEVM />
                    {colorTheme === "light" ? (
                      <div className="px-2 py-2 text-black bg-white border-2 rounded-full border-grayc-950 dark:bg-grayc-900 dark:text-white">
                        <svg
                          onClick={() => setTheme("light")}
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div className="px-2 py-2 text-white bg-gray-900 border-2 border-gray-800 rounded-full">
                        <svg
                          onClick={() => setTheme("dark")}
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
      {/* <ModalWeb3 /> */}
    </>
  );
};

export const Footer = () => {
  return (
    <>
      <section className="px-4 pt-20 pb-6 transition-all duration-500 bg-white dark:bg-grayc-900 lg:px-28 md:px-16 linear">
        <footer
          className="mx-auto p-10 rounded-xl"
          style={{
            background: "linear-gradient(135deg, #F8FAFC, #E2E8F0, #CBD5E1)",
          }}
        >
          <div className="grid lg:grid-cols-5 sm:grid-cols-2 lg:gap-0 gap-y-6">
            <div className="">
              <div className="flex items-center justify-start gap-2 mb-5">
                {/* <img src="/images/logo-dark.png" height="28" alt="" /> */}
                <h1
                  className="text-xl font-bold"
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #10448A, #1E5A8A, #2563EB)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  BlockSAFU BSC
                </h1>
              </div>
              <div className="space-y-4">
                <p className="text-gray-700">
                  Building Trust, Delivering Security, Creating Tomorrow's
                  Financial Freedom
                </p>
              </div>
            </div>
            <div className="pl-0 md:pl-0 lg:pl-10">
              <h1 className="mb-5 text-xl font-semibold text-gray-800 title-font">
                Products
              </h1>
              <ul className="space-y-2 text-gray-700">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open("https://token.blocksafu.com", "_blank");
                    }}
                    className="hover:text-gray-900 transition-colors"
                  >
                    Tokenomic
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open("https://blocksafu.com", "_blank");
                    }}
                    className="hover:text-gray-900 transition-colors"
                  >
                    Audit
                  </a>
                </li>
              </ul>
            </div>
            <div className="pl-0 md:pl-0 lg:pl-10">
              <h1 className="mb-5 text-xl font-semibold text-gray-800 title-font">
                Terms
              </h1>
              <ul className="space-y-2 text-gray-700">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        "https://token.blocksafu.com/privacy",
                        "_blank"
                      );
                    }}
                    className="hover:text-gray-900 transition-colors"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        "https://token.blocksafu.com/disclaimer",
                        "_blank"
                      );
                    }}
                    className="hover:text-gray-900 transition-colors"
                  >
                    Disclaimer & Risk
                  </a>
                </li>
              </ul>
            </div>
            {/* <div className="pl-0 md:pl-0 lg:pl-10">
              <h2 className="mb-5 text-xl font-semibold text-yellowc-400 title-font dark:text-white">
                Find Us
              </h2>
              <ul className="space-y-2 text-white dark:text-gray-200">
                <li>
                  <a href="https://t.me/">Telegram Chat</a>
                </li>
                <li>
                  <a href="https://t.me/">Telegram Channel</a>
                </li>
                <li>
                  <a href="https://twitter.com/">Twitter</a>
                </li>
                <li>
                  <a href="https://twitter.com/">Discord</a>
                </li>
              </ul>
            </div> */}
          </div>
        </footer>
        <div className="mx-auto">
          <div className="container flex flex-col items-center pt-12 mx-auto space-y-5 lg:flex-row lg:space-y-0">
            <nav className="flex flex-col items-center justify-between w-full text-gray-800 lg:flex-row">
              <p className="mb-3">
                Copyright © 2025 Blocksafu BSC. All rights reserved.
              </p>
              <div
                className="flex items-center mb-4 space-x-2 font-medium text-gray-900 title-font lg:mb-0 md:mb-0"
                style={{ cursor: "pointer" }}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://t.me/blocksafuofficial", "_blank");
                  }}
                  className="px-3 py-3 text-white rounded-full transition-all duration-300"
                  style={{
                    background:
                      "linear-gradient(to right, #0D3B7A, #1A4F7A, #1E40AF)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(to right, #10448A, #1E5A8A, #2563EB)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background =
                      "linear-gradient(to right, #0D3B7A, #1A4F7A, #1E40AF)";
                  }}
                >
                  <RiTelegramLine className="w-6 h-6" />
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://t.me/Blocksafuannouncement", "_blank");
                  }}
                  className="px-3 py-3 text-white rounded-full transition-all duration-300"
                  style={{
                    background:
                      "linear-gradient(to right, #0D3B7A, #1A4F7A, #1E40AF)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(to right, #10448A, #1E5A8A, #2563EB)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background =
                      "linear-gradient(to right, #0D3B7A, #1A4F7A, #1E40AF)";
                  }}
                >
                  <FaBullhorn className="w-6 h-6" />
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://x.com/BlockSafu", "_blank");
                  }}
                  className="px-3 py-3 text-white rounded-full transition-all duration-300"
                  style={{
                    background:
                      "linear-gradient(to right, #0D3B7A, #1A4F7A, #1E40AF)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(to right, #10448A, #1E5A8A, #2563EB)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background =
                      "linear-gradient(to right, #0D3B7A, #1A4F7A, #1E40AF)";
                  }}
                >
                  <RiTwitterLine className="w-6 h-6" />
                </a>
              </div>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
};

export const Modal = ({
  title = "",
  children,
  isOpen = false,
  onClose = (e) => {},
}) => {
  return (
    <>
      {isOpen ? (
        <>
          <div className="fixed inset-0 z-50 flex justify-center pt-20 overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div className="relative w-full mx-auto my-6 md:w-1/3 lg:w-1/3 lg:max-w-3xl">
              <div className="relative flex flex-col w-full bg-white border-0 shadow-lg outline-none dark:bg-grayc-800 rounded-3xl focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-gray-400 border-solid rounded-t dark:border-grayc-800">
                  <h3 className="text-lg font-semibold text-black dark:text-white">
                    {title}
                  </h3>
                  <button
                    className="float-right p-1 ml-auto text-lg font-semibold leading-none text-black bg-transparent border-0 outline-none dark:text-white opacity-5 focus:outline-none"
                    onClick={() => onClose(false)}
                  >
                    <FaTimes className="text-black dark:text-white" />
                  </button>
                </div>

                <div className="relative flex-auto p-6">{children}</div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25" />
        </>
      ) : null}
    </>
  );
};

export const ToastContentTx = ({ title, closeToast, txHash, chainId }) => {
  return (
    <div>
      {title} <br />
      <a
        href={getAppByChainId(chainId).URL_EXPLORER + "/tx/" + txHash}
        target="_blank"
        style={{
          textDecoration: "underline",
          fontWeight: "bold",
          color: "#04A759",
        }}
        rel="noreferrer"
      >
        View Detail
      </a>
    </div>
  );
};

export const Toast = ({
  title = "",
  children,
  isOpen = false,
  onClose = (e) => {},
  duration = 60000,
}) => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    setShowToast(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (!showToast) return;
    setTimeout(() => {
      setShowToast(false);
      onClose(true);
    }, duration);
  }, [showToast]);

  return (
    <>
      {showToast ? (
        <>
          <div className="fixed inset-0 z-50 flex justify-center pt-5 overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div className="relative w-full px-4 mx-auto md:w-2/4 lg:w-2/4">
              <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                <div className="flex items-start justify-between p-3 border-b border-solid rounded-t border-yellowc-600 bg-yellowc-600">
                  <h3 className="flex items-center text-sm font-bold text-white rounded-lg">
                    <FaBell className="w-4 h-4 mr-1" /> {title}
                  </h3>
                  <button
                    className="float-right p-1 ml-auto text-sm font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-2 focus:outline-none"
                    onClick={() => {
                      setShowToast(false);
                      onClose(false);
                    }}
                  >
                    <FaTimes className="text-white" />
                  </button>
                </div>

                <div className="relative flex-auto p-3 text-xs">{children}</div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export const CopyAddress = ({ addr }) => {
  const [address, setAddress] = useState("");
  const [isToastOpen, setIsToastOpen] = useState(false);

  const getSimpleAddress = (str) => {
    return str.substr(0, 6) + "..." + str.substr(str.length - 3, str.length);
  };

  useEffect(() => {
    setAddress(getSimpleAddress(addr));
  }, [addr]);

  const onCopy = () => {
    var TempText = document.createElement("input");
    TempText.value = addr;
    document.body.appendChild(TempText);
    TempText.select();

    document.execCommand("copy");
    document.body.removeChild(TempText);
    // if ('clipboard' in navigator) {
    //   navigator.clipboard.writeText(addr)
    // } else {
    //   document.execCommand('copy', true, addr);
    // }

    toast.success("Address Copied " + getSimpleAddress(addr));
    // setIsToastOpen(true)
  };

  return (
    <div className="flex flex-row items-center justify-content-center">
      <a href={"https://bscscan.com/address/" + addr}>{address}</a>
      &nbsp;
      <button
        className="flex items-center gap-1 px-2 py-1 text-xs bg-gray-200 border border-gray-400 rounded-full dark:text-white dark:border-gray-800 dark:bg-gray-800"
        onClick={(e) => {
          e.preventDefault();
          onCopy();
        }}
      >
        Copy
      </button>
      <Toast
        title="Success"
        isOpen={isToastOpen}
        onClose={(e) => {
          setIsToastOpen(false);
        }}
      >
        Copied to Clipboard
      </Toast>
    </div>
  );
};

export const CopyButton = ({ text }) => {
  const [address, setAddress] = useState("");
  const [isToastOpen, setIsToastOpen] = useState(false);

  const getSimpleAddress = (str) => {
    return str.substr(0, 6) + "..." + str.substr(str.length - 3, str.length);
  };

  useEffect(() => {
    setAddress(getSimpleAddress(text));
  }, [text]);

  const onCopy = () => {
    var TempText = document.createElement("input");
    TempText.value = text;
    document.body.appendChild(TempText);
    TempText.select();

    document.execCommand("copy");
    document.body.removeChild(TempText);
    // if ('clipboard' in navigator) {
    //   navigator.clipboard.writeText(addr)
    // } else {
    //   document.execCommand('copy', true, addr);
    // }
    toast.success("Successfully Copied!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // setIsToastOpen(true)
  };

  return (
    <div className="flex flex-row items-center justify-content-center">
      &nbsp;
      <button
        className="flex items-center gap-1 px-2 py-1 text-xs bg-gray-200 border border-gray-400 rounded-full dark:text-white dark:border-gray-800 dark:bg-gray-800"
        onClick={(e) => {
          e.preventDefault();
          onCopy();
        }}
      >
        <RiFileCopy2Line /> Copy
      </button>
      <Toast
        title="Success"
        isOpen={isToastOpen}
        onClose={(e) => {
          setIsToastOpen(false);
        }}
      >
        Copied to Clipboard
      </Toast>
    </div>
  );
};

/** Bugs wallet connect */
export const ModalWallet = () => {
  const {
    connector,
    library,
    chainId,
    account,
    activate,
    deactivate,
    active,
    error,
  } = useWeb3React();

  // handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = React.useState();
  React.useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined);
    }
  }, [activatingConnector, connector]);

  // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect();

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector);

  const [isSelectWalletOpen, setIsSelectWalletOpen] = useState(false);
  const onClick = (p) => {
    try {
      activate(p, undefined, true);
    } catch (ex) {
      console.log(ex);
    }
  };
  const getSimpleAddress = (str) => {
    return str.substr(0, 6) + "..." + str.substr(str.length - 3, str.length);
  };
  useEffect(() => {
    setIsSelectWalletOpen(false);
  }, [active]);

  const logout = () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Do you want to Log Out?")) {
      deactivate();
    }
  };
  return (
    <>
      {!active ? (
        <button
          onClick={() => setIsSelectWalletOpen(true)}
          className={"rounded-lg text-white bg-yellowc-600 px-3 py-2"}
        >
          Connect Wallet
        </button>
      ) : (
        <button
          onClick={() => logout()}
          className={"rounded-full text-white bg-yellowc-600 px-3 py-2"}
        >
          {getSimpleAddress(account)}
        </button>
      )}
      <Modal
        title={"Select Wallet"}
        isOpen={isSelectWalletOpen}
        onClose={(e) => setIsSelectWalletOpen(e)}
      >
        <div className={"grid grid-cols-2 gap-y-4 gap-x-2"}>
          {/*<CardWebooWallet onClick={(p) => onClick(p)} />*/}
          <CardMetamask onClick={(p) => onClick(p)} />
          <CardWalletConnect onClick={(p) => onClick(p)} />
        </div>
      </Modal>
    </>
  );
};

export const ModalWeb3 = () => {
  const [isSelectWalletOpen, setIsSelectWalletOpen] = useState(false);
  const [state, dispatch] = useContext(Context);

  useEffect(async () => {
    setIsSelectWalletOpen(state.isTriggerConnectWallet);
    if (state.web3) {
      const chainId = await state.web3.eth.getChainId();
    }
    if (state.web3Logout) doLogout();
  }, [state]);

  useEffect(async () => {
    try {
      await onClickMetamask();
    } catch (e) {
      console.error(e);
    }
  }, []);

  const onClickMetamask = async () => {
    const providerOptions = {
      /* See Provider Options Section */
      injected: {
        display: {
          // logo: "https://cdn.webooswap.com/storage/file/file_202201221104014935_1642849441.png",
          name: "Injected",
          description: "Connect with the provider in your Browser",
        },
        package: null,
      },
    };
    const web3Modal = new Web3Modal({
      // network: "mainnet", // optional
      cacheProvider: false, // optional
      providerOptions, // required
      theme: "dark",
    });
    const provider = await web3Modal.connectTo("injected");
    const web3 = new Web3(provider);
    const accounts = await web3.eth.getAccounts();
    const chainId = await web3.eth.getChainId();
    await validateChain(chainId);
    providerEvent(provider, web3);
    dispatch({
      type: "SET_WEB3",
      payload: {
        web3: web3,
        web3modal: web3Modal,
      },
    });
    dispatch({ type: "SET_ACCOUNT", payload: accounts[0] });
  };

  const onClickWC = async () => {
    const providerOptions = {
      /* See Provider Options Section */
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          rpc: {
            56: "https://bsc-dataseed1.defibit.io",
          },
        },
      },
    };
    const web3Modal = new Web3Modal({
      // network: "mainnet", // optional
      cacheProvider: false, // optional
      providerOptions, // required
      theme: "dark",
    });
    const provider = await web3Modal.connectTo("walletconnect");
    const web3 = new Web3(provider);
    const accounts = await web3.eth.getAccounts();
    const chainId = await web3.eth.getChainId();
    await validateChain(chainId);
    providerEvent(provider, web3);
    dispatch({
      type: "SET_WEB3",
      payload: {
        web3: web3,
        web3modal: web3Modal,
      },
    });
    dispatch({ type: "SET_ACCOUNT", payload: accounts[0] });
  };

  const providerEvent = (provider, web3) => {
    provider.on("accountsChanged", (accounts) => {
      let acc = web3.ethers.toChecksumAddress(accounts[0]);
      dispatch({ type: "SET_ACCOUNT", payload: acc });
    });

    provider.on("chainChanged", async (chainId) => {
      let chain_id = chainId;
      if (web3.ethers.isHex(chainId))
        chain_id = web3.ethers.hexToNumber(chainId);
      await validateChain(chain_id);
    });

    provider.on("connect", (info) => {
      console.log(info);
    });

    provider.on("disconnect", (error) => {
      console.log(error);
      dispatch({ type: "SET_ACCOUNT", payload: null });
    });

    setTimeout(async () => {
      dispatch({ type: "STOREHASH" });
    }, [2000]);
  };

  const validateChain = async (chainId) => {
    const chain_id = chainId;
    // if(state.web3.ethers.isHex(chain_id)) chain_id = state.web3.ethers.hexToNumber(chain_id)
    // alert(state.web3.ethers.isHex(chain_id))
    if (!getEnv().ALLOWED_CHAIN_ID.includes(chain_id)) {
      alert("Wrong Network");
      console.log(chainId);
      dispatch({ type: "LOGOUT_WALLET_CONNECT", payload: false });
    }

    dispatch({ type: "SET_CHAIN_ID", payload: chainId });
  };

  const doLogout = async () => {
    // await state.web3modal.clearCachedProvider();
    dispatch({
      type: "SET_WEB3",
      payload: {
        web3: null,
        web3modal: null,
      },
    });
    dispatch({ type: "SET_CHAIN_ID", payload: null });
    dispatch({ type: "LOGOUT_WALLET_CONNECT", payload: false });

    setTimeout(async () => {
      dispatch({ type: "STOREHASH" });
    }, [2000]);
  };

  return (
    <>
      <Modal
        title={"Select Wallet"}
        isOpen={isSelectWalletOpen}
        onClose={(e) => setIsSelectWalletOpen(e)}
      >
        <div className={"flex flex-col gap-y-3"}>
          {/*<CardWebooWallet onClick={(p) => onClickMetamask()} />*/}
          <CardMetamask onClick={(p) => onClickMetamask()} />
          <CardWalletConnect onClick={(p) => onClickWC()} />
        </div>
      </Modal>
    </>
  );
};

export const ModalWeb3Test = () => {
  const onConnect = async () => {
    const providerOptions = {
      /* See Provider Options Section */
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          rpc: {
            97: "https://data-seed-prebsc-1-s1.binance.org:8545",
          },
        },
      },
    };

    const web3Modal = new Web3Modal({
      // network: "mainnet", // optional
      cacheProvider: false, // optional
      providerOptions, // required
      theme: "dark",
    });

    const instance = await web3Modal.connectTo("walletconnect");

    const provider = new ethers.BrowserProvider(instance);
    // const signer = provider.getSigner();
    // alert("tes")
  };
  return (
    <button
      onClick={() => onConnect()}
      className={"rounded-lg text-white bg-yellowc-600 px-3 py-2"}
    >
      Connect Wallet
    </button>
  );
};

export const CardMetamask = ({ onClick = (e) => {} }) => {
  return (
    <button
      className={
        "items-center border-2 border-gray-400 dark:border-grayc-900 rounded-full text-center flex flex-row justify-between py-2 hover:border-3 hover:border-red-600 px-8 gap-y-2"
      }
      onClick={() => onClick(injected)}
    >
      <div className={"text-sm font-bold text-black dark:text-white"}>
        Metamask
      </div>
      <img
        alt={"Metamask"}
        src={"./images/metamask.png"}
        style={{
          width: 30,
          height: 30,
        }}
      />
    </button>
  );
};

export const CardWebooWallet = ({ onClick = (e) => {} }) => {
  return (
    <button
      className={
        "items-center border-2 rounded-full border-gray-400 dark:border-grayc-900 text-center flex flex-row justify-between py-2 hover:border-3 hover:border-red-600 px-8 gap-y-2"
      }
      onClick={() => onClick(injected)}
    >
      <div className={"text-sm font-bold text-black dark:text-white"}>
        Weboo Wallet
      </div>
      <img
        alt={"WebooWallet"}
        src={
          "https://cdn.webooswap.com/storage/file/file_202201221439036521_1642862343.svg"
        }
        style={{
          width: 30,
          height: 30,
        }}
      />
    </button>
  );
};

export const CardWalletConnect = ({ onClick = (p) => {} }) => {
  return (
    <button
      className={
        "items-center border-2 rounded-full border-gray-400 dark:border-grayc-900 text-center flex flex-row justify-between py-2 hover:border-3 hover:border-red-600 px-8 gap-y-2"
      }
      onClick={() => onClick(walletconnect)}
    >
      <div className={"text-sm font-bold text-black dark:text-white"}>
        Wallet Connect
      </div>
      <img
        alt={"Wallet Connect"}
        src={"./images/wallet_connect.png"}
        style={{
          width: 30,
          height: 30,
        }}
        loading="lazy"
      />
    </button>
  );
};

export const LoadingWeboo = () => {
  return (
    <div className={"flex flex-col items-center justify-center animate-pulse"}>
      <img
        src={"/images/logo-dark.png"}
        style={{
          width: 300,
          height: 100,
        }}
        className={"mr-2"}
        alt={"Dex Name"}
      />
      Loading...
    </div>
  );
};

export const NotFound = () => {
  return (
    <div className={"flex flex-col"}>
      <img
        src={
          "https://cdn.webooswap.com/storage/file/file_202201221439036521_1642862343.svg"
        }
        style={{
          width: 100,
          height: 100,
        }}
        className={"mr-2"}
        alt={"Dex Name"}
      />
      Not Found.
    </div>
  );
};

export const ChainIconCircle = ({
  icon1,
  icon2,
  size = 80,
  borderWidth = 3,
}) => {
  return (
    <div className={"flex flex-row items-center justify-center"}>
      <img
        src={icon1}
        style={{
          width: size,
          height: size,
        }}
        className={
          "rounded-full p-0.5 border-yellowc-600 border-" + borderWidth
        }
        alt={"Weboo"}
      />
      <span
        className={"rounded-full p-1 bg-yellowc-600"}
        style={{
          position: "absolute",
          borderWidth: borderWidth,
        }}
      />
      <img
        src={icon2}
        style={{
          width: size,
          height: size,
        }}
        className={
          "rounded-full p-0.5 border-yellowc-600 border-" + borderWidth
        }
        alt={"Weboo"}
      />
    </div>
  );
};

export const BtnWalletConnect = ({ children, isRounded = false }) => {
  const [state, dispatch] = useContext(Context);

  useEffect(() => {
    if (!state.web3) {
      // dispatch({
      //   type: "CONNECT_WALLET",
      //   payload: true,
      // });
    }
  }, []);

  const onConnectWallet = () => {
    dispatch({
      type: "CONNECT_WALLET",
      payload: true,
    });
  };

  return (
    <>
      {!state.isConnectWallet ? (
        <button
          onClick={() => onConnectWallet()}
          className={
            "text-white bg-grayc-900 dark:bg-grayc-900 dark:text-white dark:border-grayc-950 border-1 border-gray-400 px-4 py-2.5 md:px-6 md:py-4 lg:px-6 lg:py-4 flex items-center gap-2" +
            (isRounded ? " rounded-full" : " rounded-2xl")
          }
        >
          <BsWallet2 />
          Connect
        </button>
      ) : (
        children
      )}
    </>
  );
};

export const CircleLoading = ({ size }) => {
  return (
    <div className={"animate-pulse"}>
      <div className={`bg-red-300 rounded-full w-${size} h-${size}`} />
    </div>
  );
};

export const ModalTxHash = ({
  txHash = null,
  isReceipt = false,
  onReceiptClose = () => {},
}) => {
  const [state, dispatch] = useContext(Context);
  const [storeHash, setStoreHash] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [showReceipt, setShowReceipt] = useState(false);
  const [urlExplorer, setUrlExplorer] = useState("https://bscscan.com");
  const { chainId } = useAppKitNetwork();

  useState(async () => {
    if (state && state.web3) {
      setUrlExplorer(getAppByChainId(chainId).URL_EXPLORER);
      // setUrlExplorer("https://bscscan.com");
      setStoreHash(state.web3.storeHash);
    }
  }, [state]);

  useEffect(() => {
    if (!txHash) return setShowModal(false);
    else {
      setTimeout(() => {
        setShowModal(true);
      }, 2000);
    }
  }, [txHash]);

  useEffect(() => {
    if (!isReceipt) return;
    setShowReceipt(true);
  }, []);

  return (
    <>
      {showModal ? (
        <>
          <Modal
            title={"Transaction Submitted"}
            isOpen={showModal}
            onClose={() => setShowModal(false)}
          >
            <div className={"flex flex-col items-center gap-y-3"}>
              <FaArrowCircleUp size={100} />
              <a
                href={urlExplorer + "/tx/" + txHash}
                target={"_blank"}
                rel={"noreferrer"}
                className={
                  "no-underline font-bold flex flex-row gap-x-3 justify-center items-center text-black dark:text-white"
                }
              >
                <span>View On Explorer</span>
                <FaExternalLinkAlt />
              </a>
            </div>
          </Modal>
        </>
      ) : null}
      {/*<Toast isOpen={showReceipt} title={"Transaction Receipt"} onClose={()=>{setShowReceipt(false);onReceiptClose()}}>*/}
      {/*  <a href={urlExplorer+"/tx/"+txHash} target={"_blank"} rel={"noreferrer"} className={"underline font-bold flex text-sm flex-row gap-x-3"}>*/}
      {/*    <span>View On Explorer</span>*/}
      {/*    <FaExternalLinkAlt />*/}
      {/*  </a>*/}
      {/*</Toast>*/}
    </>
  );
};

export const Empty = ({ text }) => {
  return (
    <div
      className={
        "w-full text-3xl flex items-center text-center align-center flex-col"
      }
    >
      <span>{text}</span>
    </div>
  );
};

export const LastTxAccount = ({ loop = 3, txHash }) => {
  const [state, dispatch] = useContext(Context);
  const [listTx, setListTx] = useState([]);
  const { chainId } = useAppKitNetwork();

  const getTx = async () => {
    if (state.account) {
      setListTx([]);

      await state.web3.eth.getTransactionCount(state.account).then((b) => {
        if (b < loop) loop = b;
        let tmp = [];
        // for(let i=1;i<=loop;i++){
        //   state.web3.eth.getBlock(b-i).then((Block)=>{
        //     console.log(Block)
        //     state.web3.eth.getTransactionFromBlock(Block.number, 10000).then(txBlock=>{
        //       console.log(txBlock)
        //     })
        //     // state.web3.eth.getTransactionFromBlock(Block.hash, 1)
        //     // .then(res=>console.log(res));
        //     // tmp.push(Block)
        //   })
        // }
        setListTx(tmp);
      });
      // await state.web3.eth.getPastLogs({
      //   address: state.account,
      // }).then(console.log);
    }
  };

  useEffect(() => {
    getTx();
  }, [state, txHash]);

  return (
    <div className="text-right">
      <ul>
        {listTx.map((v, i, a) => {
          return (
            <li key={v.hash}>
              <small>
                <a
                  href={getAppByChainId(chainId).URL_EXPLORER + "/tx/" + v.hash}
                  target={"_blank"}
                  style={{ fontWeight: "bold" }}
                  rel="noreferrer"
                >
                  View Detail {getSimpleAddress(v.hash)}
                </a>
              </small>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export const LoadingWrapper = ({ children, isLoading }) => {
  return (
    <>
      {isLoading ? (
        <div className={"flex items-center justify-center"}>
          <ClipLoader color={"#D0980B"} loading={isLoading} size={20} />
        </div>
      ) : (
        children
      )}
    </>
  );
};
